// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var DeviceType;
(function (DeviceType) {
    DeviceType["DEVICE_TYPE_UNSPECIFIED"] = "DEVICE_TYPE_UNSPECIFIED";
    DeviceType["DEVICE_TYPE_DESK_PHONE"] = "DEVICE_TYPE_DESK_PHONE";
    DeviceType["DEVICE_TYPE_SOFTPHONE"] = "DEVICE_TYPE_SOFTPHONE";
    DeviceType["DEVICE_TYPE_MOBILE_APP"] = "DEVICE_TYPE_MOBILE_APP";
})(DeviceType || (DeviceType = {}));
export var DeviceType_index;
(function (DeviceType_index) {
    DeviceType_index[DeviceType_index["DEVICE_TYPE_UNSPECIFIED"] = 0] = "DEVICE_TYPE_UNSPECIFIED";
    DeviceType_index[DeviceType_index["DEVICE_TYPE_DESK_PHONE"] = 1] = "DEVICE_TYPE_DESK_PHONE";
    DeviceType_index[DeviceType_index["DEVICE_TYPE_SOFTPHONE"] = 2] = "DEVICE_TYPE_SOFTPHONE";
    DeviceType_index[DeviceType_index["DEVICE_TYPE_MOBILE_APP"] = 3] = "DEVICE_TYPE_MOBILE_APP";
})(DeviceType_index || (DeviceType_index = {}));
export var Action;
(function (Action) {
    Action["ACTION_UNSPECIFIED"] = "ACTION_UNSPECIFIED";
    Action["ACTION_PAIR"] = "ACTION_PAIR";
    Action["ACTION_CONNECT"] = "ACTION_CONNECT";
    Action["ACTION_DISCONNECT"] = "ACTION_DISCONNECT";
    Action["ACTION_FORGET"] = "ACTION_FORGET";
    Action["ACTION_LEGACY_CONNECT"] = "ACTION_LEGACY_CONNECT";
    Action["ACTION_LEGACY_DISCONNECT"] = "ACTION_LEGACY_DISCONNECT";
    Action["ACTION_LEGACY_UPDATE"] = "ACTION_LEGACY_UPDATE";
})(Action || (Action = {}));
export var Action_index;
(function (Action_index) {
    Action_index[Action_index["ACTION_UNSPECIFIED"] = 0] = "ACTION_UNSPECIFIED";
    Action_index[Action_index["ACTION_PAIR"] = 1] = "ACTION_PAIR";
    Action_index[Action_index["ACTION_CONNECT"] = 2] = "ACTION_CONNECT";
    Action_index[Action_index["ACTION_DISCONNECT"] = 3] = "ACTION_DISCONNECT";
    Action_index[Action_index["ACTION_FORGET"] = 4] = "ACTION_FORGET";
    Action_index[Action_index["ACTION_LEGACY_CONNECT"] = 5] = "ACTION_LEGACY_CONNECT";
    Action_index[Action_index["ACTION_LEGACY_DISCONNECT"] = 6] = "ACTION_LEGACY_DISCONNECT";
    Action_index[Action_index["ACTION_LEGACY_UPDATE"] = 7] = "ACTION_LEGACY_UPDATE";
})(Action_index || (Action_index = {}));
export const UserService = {
    // SetActiveDevice sets the active device for a user
    SetActiveDevice(fn, req) {
        return fn(`/phone/user/v1/set-active-device`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // DeactivateDevice disconnects the device. It removes the device from being active, but remains as saved.
    DeactivateDevice(fn, req) {
        return fn(`/phone/user/v1/deactivate-device`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ForgetDevice removes the device from both the active and saved device tables
    ForgetDevice(fn, req) {
        return fn(`/phone/user/v1/forget-device`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // PairDevice pairs a device to a user, overwriting the user's active device and saving it to the saved device table
    PairDevice(fn, req) {
        return fn(`/phone/user/v1/pair-device`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // FindUser searches the active table for a user given a sip profile.
    FindUser(fn, req) {
        try {
            fm.validateUrlParam(req["sipProfileId"], "sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/user/v1/find/${req["sipProfileId"]}?${fm.renderURLSearchParams(req, ["sipProfileId"])}`, { method: "GET" });
    },
    // HealthCheck returns a message to indicate the service is healthy
    HealthCheck(fn, req) {
        return fn(`/phone/user/v1/health-check?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListSavedDevices(fn, req) {
        return fn(`/phone/user/v1/list/saved-devices?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ConfirmPair(fn, req) {
        return fn(`/phone/user/v1/confirm-pair`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ManualPair(fn, req) {
        return fn(`/phone/user/v1/manual-pair`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // LegacyFindUser searches the legacy registered sip profiles table to determine which user to generate a cdr for.
    // this is to facilitate the migration of cdr generation from 1.0 to 2.0.
    LegacyFindUser(fn, req) {
        try {
            fm.validateUrlParam(req["sipProfileId"], "sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/user/v1/legacy/find/${req["sipProfileId"]}?${fm.renderURLSearchParams(req, ["sipProfileId"])}`, { method: "GET" });
    },
    // ConnectedDevice returns the connected device for a user.
    ConnectedDevice(fn, req) {
        return fn(`/phone/user/v1/connected-device?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // SetPreferredPhoneNumber sets the preferred phone number for a user
    SetPreferredPhoneNumber(fn, req) {
        return fn(`/phone/user/v1/preferred-number`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // GetPreferredPhoneNumber returns the preferred phone number for a user
    GetPreferredPhoneNumber(fn, req) {
        return fn(`/phone/user/v1/preferred-number?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // RemovePreferredPhoneNumber removes the preferred phone number for a user
    RemovePreferredPhoneNumber(fn, req) {
        return fn(`/phone/user/v1/preferred-number?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
};
